<template>
    <div v-resize="onResize">
        <h2>Two candidate preferred preference flow</h2>
        <br/>
        <loader v-if="loading" />                      
        <v-data-table v-if="!loading" :headers="headers"                    
                    :items="data.filter(d => d.Candidate !== '')"
                    :disable-initial-sort="true"
                    :hide-headers="isMobile"
                    :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                    hide-actions>
            <template v-slot:items="props">
                <tr v-if="isMobile">
                        <td>
                            <div class="flex-content">
                                <div class="flex-item pt-2">
                                    <h3 class="pb-xs-0">
                                        {{ props.item.Candidate }}
                                    </h3>
                                </div>
                                <div class="flex-item" data-label="Party">
                                    {{ props.item.Party }}
                                </div>
                                <template v-for="header of extraHeaders">
                                    <div class="flex-item flex-item-col" :key="header.value" v-if="header.text !== '%'" :data-label="header.candidate">
                                        {{ props.item.Votes.find(v => v.ToCandidate.Candidate === header.candidate).Count }} ({{ props.item.Votes.find(v => v.ToCandidate.Candidate === header.candidate).Percentage }}%)
                                    </div>
                                </template>
                            </div>
                        </td>
                    </tr>
                <tr v-else>
                    <td class="text-xs-left">{{ props.item.Candidate }}</td>
                    <td class="text-xs-left">{{ props.item.Party }}</td>
                    <template v-for="header of extraHeaders">
                        <td :key="header.value" v-if="header.text !== '%'">
                            {{ props.item.Votes.find(v => v.ToCandidate.Candidate === header.candidate).Count }}
                        </td>
                        <td :key="header.value" v-if="header.text === '%'">
                            {{ props.item.Votes.find(v => v.ToCandidate.Candidate === header.candidate).Percentage }}
                        </td>                        
                    </template>
                </tr>
            </template>
        </v-data-table>                 
    </div>
</template>
<script>
import Loader from '@/components/Loader.vue';
import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    props: ['division', 'year'],
    components: {
        Loader
    },
    created() {
        this.initialiseData();
    },
    mounted() {
        this.onResize();
    },
    data() {
        return {
            data: [],
            isMobile: false,
            loading: true
        }
    },
    methods: {
        initialiseData: function () {
            this.loading = true;
            const url = `Elections/TwoCandidatePreferredPreferenceFlow?divisionName=${this.division}&year=${this.year}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.data = response.data;
                    this.loading = false;
                });
        },
        onResize() {
            if (window.innerWidth < 769){
                this.isMobile = true;
            }
            else{
                this.isMobile = false;
            }
        },
    },
    computed: {
        headers() {
            const headers = [{
                text: 'Candidate',
                value: 'Candidate'
            },
            {
                text: 'Party',
                value: 'Party'
            }];
            
            return [...headers, ...this.extraHeaders];
        },
        extraHeaders() {
           return this.data.length > 0 ? 
            // add header for candidates 
            this
                .data
                .find(d => d.Candidate === 'First Preferences')
                .Votes
                .map(d => d.ToCandidate)
                .flatMap(d => [
                    { text: d.Candidate, candidate: d.Candidate, value: d.Candidate.Votes },
                    { text: '%', candidate: d.Candidate, value: d.Candidate.Votes }
                ]) : [];          
        }
    }
}

</script>